import { GetCommentWithRepliesByIdQuery_getCommentWithReplies_replies } from "@bakbak/controller";
import { Avatar, List } from 'antd';
import * as React from 'react';
import * as isEqual from "react-fast-compare";


interface Props {
  replyList: GetCommentWithRepliesByIdQuery_getCommentWithReplies_replies[];
}
export class ReplyListView extends React.Component<Props> {
  state = {
    data: [],
    loading: false,
    hasMore: true,
  }
  shouldComponentUpdate(nextProps: Props) {
    return !(isEqual(this.props.replyList, nextProps.replyList))
  }
  loadMore = () => {
    console.log('loading more');
  }
  renderItem = (reply: GetCommentWithRepliesByIdQuery_getCommentWithReplies_replies) => (
    <List.Item key={reply.id}>
      <List.Item.Meta
        avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
        title={reply.author.userName}
        description={reply.text}
      />
    </List.Item>
  )
  render() {
    const { replyList } = this.props;
    return (
      replyList.map(reply => this.renderItem(reply))
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/reply/list/ReplyListView.tsx